import React, {Component} from 'react';
import ClientSideCacheController from '../ClientSideCacheController'
import Cannonicalize from '../Cannonicalize'
import Analytics from '../Analytics'

class NineDayForecast extends Component{
  constructor(props){
    super(props)
    this.affiliate = this.props.affiliate;
    this.state = {
      forecasts: [],
      detailIndex: -1
    }

    this.maxTemp = 0;
  }



  componentWillMount(){
    try {
      this.setState(Cannonicalize.forecast(this.props.FRN_rawResponses[0].data))
    } catch (e) {
      e.message += ' in NineDayForecast'
      Analytics.reportError(e)
    }

    if(typeof window !== 'object')
      return
    ClientSideCacheController.setAffiliate(this.props.affiliate)
    ClientSideCacheController.get('forecast').then((data)=>{
      data.detailIndex = -1 ;
      this.setState(data)
    })
    /* just to test traffic to baron relay */
    ClientSideCacheController.get('nineDayForecast').then((data)=>{
      
      console.log('nineDayForecast testing',data);
    }).catch(e=>{
      let error = new Error('*Back-end* nineDayForecast failure')
      Analytics.reportError(error)
    })
    /* stop testing here */
  }

  componentDidMount(){
    document.onkeydown = (e)=>{
      if(e.keyCode === 27)
        this.setState({detailIndex: -1})
    }
  }


  render(){
    if(this.state.forecasts.length < 7){
      console.log("Less than 7 days render null");
      return null
    }
    try{
      return(
        <div className="gnm-nine-day-forecast"  >
          <div className='scrollable-inner'>
            <div style={{width:'900px'}} className="hidden-md hidden-lg"> {/* 100 is built in to CSS*/}
            {this.state.forecasts.map((f,i,all)=>{
              return  (
                <div key={i}>
                  <Day {...f} affiliate={this.affiliate} onClick={()=>{
                      this.setState({detailIndex: i})
                    }} />
                  <Detail {...f} detailIndex={this.state.detailIndex} key={'k' + i} index={i} onClick={()=>{
                      this.setState({detailIndex: -1})
                    }} />
                </div>
              )
            }).slice(0,9)}
            </div>
            <div className="visible-md-block visible-lg-block"> {/* 100 is built in to CSS*/}
            {this.state.forecasts.map((f,i,all)=>{
              return  (
                <div key={i}>
                  <Day {...f} affiliate={this.affiliate} onClick={()=>{
                      this.setState({detailIndex: i})
                    }} />
                  <Detail {...f} detailIndex={this.state.detailIndex} key={'k' + i} index={i} onClick={()=>{
                      this.setState({detailIndex: -1})
                    }} />
                </div>
              )

            }).slice(0,9)}
            </div>
          </div>
        </div>
      )
    }
    catch(e){
      e.message += ' render failure in NineDayForecast'
      Analytics.reportError(e)
      return null
    }


  }
}

class Detail extends Component{

  render(){


    return(
      <div className="full-info" style={{display: this.props.detailIndex === this.props.index? 'block': 'none'}} onClick={this.props.onClick} >
        <div className='clickable-clear-background'></div>
        <div className="full-title">{this.props.extendedTitle} <span className="fa fa-close"></span></div>
        <div className="full-contents" >
          <div className="condition">{this.props.condition}</div>
          <img className=" fixed-width" src={this.props.conditionicon}></img>
          <span className='high'>{this.props.high}&deg;</span>
            {
              (this.props.precipToggle)
              ? <ul>
                  <li>Chance of Rain</li>
                  <li ><h4>{this.props.precipitation}</h4></li>
                </ul>
              : null
            }
            {
              (this.props.winddirection && this.props.windspeedmax)
              ? <ul>
                  <li>Wind</li>
                  <li >{this.props.winddirection + ' ' + this.props.windspeedmax + ' MPH'}</li>
                </ul>
              : null
            }
          <ul>
            <li>Sunrise</li>
            <li><p>{this.props.sunrise}</p></li>
          </ul>
          <ul>
            <li>Sunset</li>
            <li><p>{this.props.sunset}</p></li>
          </ul>
          <p>{this.props.description}</p>
        </div>



      </div>
    )
  }
}

class Day extends Component{

  render(){

    return (
              <div className="day" onClick={this.props.onClick}>
                <div className= "summary" >
                  <div className="title ">
                    <h2 className={ this.props.date}>{this.props.date.substring(0,3)}</h2>
                  </div>
                  <div className="hidden-xs hidden-sm condition-description">{this.props.condition}</div>
                  <div className="img">
                    <img src={this.props.conditionicon} className="img-responsive"></img>
                  </div>
                  <h3>{this.props.high}&deg;</h3>
                  <h4>{this.props.low}&deg;</h4>
                  <h5 >
                    {this.props.precipitation ? <span className="fa fa-umbrella"/> : null}
                    {this.props.precipitation ? this.props.precipitation : null}
                  </h5>
                  <div className="details">View Details</div>
                </div>
              </div>
          )
  }
}


export default NineDayForecast



// WEBPACK FOOTER //
// ./app/components/custom/ssr/NineDayForecast/index.js